app.controller('BrowseController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.breadcrumbs = [];

    let stateList = [];
    let choiceCount = 0;

    $scope.active_classes = "";
    $scope.page_modifiers = {};

    $scope.state_ids = {};
    $scope.state_models = {};

    $scope.browse_initialized = false;

    $scope.fullOnWhite = function () {
        const stateIDs = $rootScope.navigation_model.state_ids;
        const stateList = $rootScope.navigation_model.state_list;
        if (stateIDs.browse_id === 'solution' && stateIDs.solution_id) {
            return true;
        }
        const lastModel = stateList[stateList.length - 1].model;
        if (['collection_product', 'individual_product'].includes(lastModel.id)) {
            return true;
        }
        const methodInputModel = $rootScope.navigation_model.state_models.method_input;
        if (methodInputModel && $scope.isModelVisible(methodInputModel)) {
            return true;
        }
        const tabModel = $rootScope.navigation_model.state_models.tab;
        if (tabModel && $scope.isModelVisible(tabModel)) {
            return true;
        }
    }

    $scope.isModelVisible = function (model) {
        const stateList = $rootScope.navigation_model.state_list;
        let found = false;
        for (let i = stateList.length - 1; i >= 0; i--) {
            if (stateList[i].model_id === model.id) {
                found = true;
            }
        }
        if (!found) {
            return false;
        }
        const lastState = stateList[stateList.length - 1];
        if (lastState.model_id === model.id && !lastState.choice_id) {
            return true;
        }
        if (model.hide_with) {
            for (let i = stateList.length - 1; i >= 0; i--) {
                if (model.hide_with.includes(stateList[i].model_id)) {
                    return false;
                }
            }
            return true;
        } else if (model.showUntil) {
            let haveOther = false;
            for (let i = stateList.length - 1; i >= 0; i--) {
                const modelID = stateList[i].model_id;
                if (modelID === model.id) {
                    return true;
                }
                if (model.showUntil.includes(modelID)) {
                    return !haveOther;
                } else {
                    haveOther = true;
                }

            }
            return false;
        }
        return !!model.show_with_children;
    }

    $scope.categoryName = function () {
        const stateIDs = $rootScope.navigation_model.state_ids;
        const stateValues = $rootScope.navigation_model.state_values;

        if (stateIDs.component_id === "clearance") {
            return "Clearance";
        }

        if (stateIDs.component_id === "promotional") {
            if(stateIDs.parent_category_group_id === "promotional_printed"){
                return "Order Printed Promotional Materials";
            }
            if(stateIDs.parent_category_group_id === "promotional_sample"){
                return "Order Samples";
            }
            if(stateIDs.parent_category_group_id === "promotional_swatch"){
                return "Order Swatches";
            }
            if(stateIDs.parent_category_group_id === "promotional_other"){
                return "Order Other Promotional Materials";
            }
            return "Order Promotional Materials";
        }

        if (stateIDs.browse_id === "range_info") {
            return stateValues.rangeInfoName ? stateValues.rangeInfoName : "Range Info";
        }

        if (stateIDs.browse_id === "solution") {
            if (stateValues.solutionName) {
                return stateValues.solutionName;
            }
        }

        const siteRangeName = stateValues.site_range_name ? stateValues.site_range_name : "";
        let contentName = stateValues.component_name ? stateValues.component_name : "";

        const stateList = $rootScope.navigation_model.state_list;
        const ignoreModelIDs = ['method_input', 'method_product'];
        const propertyIDs = ["door_type", "site_range", "colour_route", "style_route", "assembly"];
        for (let i = stateList.length - 1; i >= 1; i--) {
            const model = stateList[i].model;
            if (
                model.id === "tile" ||
                model.id === "collection_product" ||
                model.id === "option_term" ||
                (model.id === "method_input" && stateIDs.browse_id === "component")
            ) {
                let found = false;
                for (let j = i; j >= 0; j--) {
                    const choice = stateList[j].choice;
                    if (!choice) {
                        continue;
                    }
                    if (propertyIDs.includes(choice.model_id)) {
                        break;
                    }
                    if (!ignoreModelIDs.includes(choice.model_id)) {
                        contentName = choice.page_title ? choice.page_title : choice.name;
                        found = true;
                        break;
                    }
                }
                if (found) {
                    break;
                }
            }
        }


        if (!siteRangeName && !contentName) {

            if (stateIDs.browse_id === "component") {
                return "Order by Component";
            }
            return "";
        }

        if (contentName) {
            const currentModel = stateList[stateList.length - 1].model;

            let nonManufactured = false;
            for (let i = stateList.length - 1; i >= 1; i--) {
                const choice = stateList[i].choice;
                if (choice && choice.state_ids && choice.state_ids.base_component_id && !(choice.requires_colour || choice.requires_style)) {
                    nonManufactured = true;
                    break;
                }
            }
            if (!nonManufactured && !propertyIDs.includes(currentModel.id) && siteRangeName && !contentName.includes(siteRangeName)) {
                return siteRangeName + " " + contentName;
            }
            return contentName;
        }

        return siteRangeName;
    }

    $scope.getBackChoice = function () {
        const ignoreModelIDs = ['method_input', 'method_product', 'tab', 'select'];
        const stateList = $rootScope.navigation_model.state_list;
        if (stateList.length < 2) {
            return null;
        }
        const stateIDs = $rootScope.navigation_model.state_ids;
        const fromModelID = stateList[stateList.length - 2].model_id;
        const toMatrix = stateIDs.method_product_id === "matrix" && fromModelID !== "method_product";
        const toFilter = stateIDs.methodInputID === "filter" && fromModelID !== "method_input" && (stateIDs.browse_id === "component" || !stateIDs.component_id)
        const browseID = stateIDs.browse_id;
        const currentStateIndex = stateList.length - 1;
        for (let i = currentStateIndex - 1; i > 0; i--) {
            const state = stateList[i];
            const modelID = state.model_id;

            if (toMatrix) {
                if (modelID === "method_product" || state.choice.next_model_id === "method_product") {
                    return state.choice;
                }
                continue;
            } else if (toFilter) {
                if (modelID === "method_input") {
                    return state.choice;
                }
                continue;
            }

            if ((browseID === "solution" && (modelID === "solution" || modelID === "component")) || (browseID === "site_range" && modelID === "site_range")) {
                return null;
            }
            if (!ignoreModelIDs.includes(modelID)) {
                return stateList[i - 1].choice;
            }

        }

        return null;
    }

    $scope.getBackBtnTxt = function () {
        const backChoice = $scope.getBackChoice();
        if (!backChoice) {
            return null;
        }
        if (backChoice.model_id === "method_input" && backChoice.id === "filter") {
            return "Edit criteria";
        }
        let toModelID = null;
        const stateList = $rootScope.navigation_model.state_list;
        for (let i = stateList.length - 2; i >= 0; i--) {
            if (stateList[i].model_id === backChoice.model_id) {
                toModelID = stateList[i + 1].model_id
                break;
            }
        }

        const stateIDs = $scope.state_ids;
        if (toModelID === "door_type") {
            return "Change door type";
        }
        if (toModelID === "site_range") {
            return "Change range";
        }
        if (toModelID === "colour_route") {
            return "Change colour";
        }
        if (toModelID === "style_route") {
            return "Change style";
        }
        if (toModelID === "assembly") {
            return "Change assembly";
        }
        if (toModelID === "solution") {
            return "Change solution";
        }
        if (toModelID === "edge_option") {
            return "Change edge option";
        }
        if (toModelID === "handle_colour") {
            return "Change handle colour";
        }
        if (toModelID === "clicbox_colour") {
            return "Change cabinet colour";
        }
        if (toModelID === "component") {
            return "Browse Products";
        }
        if (toModelID === "tile" && stateIDs.browse_id === "solution") {
            return "Return to Step 1";
        }
        if (toModelID === "tile" || toModelID === "collection_product" || toModelID === "tab") {
            if (stateIDs.base_component_id === "solution") {
                return "Select Cabinet Size";
            }
            const stateValues = $rootScope.navigation_model.state_values;
            const name = stateValues.component_name ? stateValues.component_name : stateValues.browseName;
            if (name) {
                return (toModelID === "collection_product" ? "Change" : "Browse") + " " + name;
            }
        }
        return null;
    }

    $scope.tileStepTxt = function () {
        const stateIDs = $scope.state_ids;
        if (stateIDs.component_id === "panel_wrap") {
            if (stateIDs.browse_id === "solution") {
                return "Step 1: Choose a Style";
            }
        }
        return null;
    }

    $scope.productStepTxt = function () {
        const stateIDs = $scope.state_ids;
        if (stateIDs.component_id === "panel_wrap") {
            if (stateIDs.browse_id === "solution") {
                return "Step 2: Configuration";
            }
        }
        return null;
    }

    function updateActiveState() {

        const navigationModel = $rootScope.navigation_model;

        $scope.state_ids = navigationModel.state_ids;
        $scope.state_models = navigationModel.state_models;

        stateList = navigationModel.state_list;
        choiceCount = navigationModel.choice_count;


        updateBreadcrumbs();

        if (!$scope.browse_initialized) {
            $scope.browse_initialized = true;
        }
    }

    function updateBreadcrumbs() {

        let i;
        $scope.breadcrumbs = [
            {
                name: "Home",
                href: "/"
            }
        ];

        for (i = 0; i < stateList.length; i++) {
            const choice = stateList[i].choice;
            if (!choice) {
                break;
            }
            const model = stateList[i].model;

            let breadcrumb = null;

            const nextChoice = i < stateList.length - 1 ? stateList[i + 1].choice : null
            if (model.choice_is_breadcrumb) {
                breadcrumb = {
                    name: choice.breadcrumb_name ? choice.breadcrumb_name : choice.name
                }
                if (nextChoice && (nextChoice.model_id === "method_input" || nextChoice.model_id === "tab")) {
                    if (i < choiceCount - 2) {
                        breadcrumb.href = nextChoice.href;
                    }
                } else {
                    if (i < choiceCount - 1) {
                        breadcrumb.href = choice.href;
                    }
                }
            } else {
                const nextModel = i < stateList.length - 1 ? stateList[i + 1].model : null
                if (nextModel && nextModel.previous_choice_is_breadcrumb) {
                    breadcrumb = {
                        name: nextModel.previousChoiceBreadcrumbName ? nextModel.previousChoiceBreadcrumbName : (choice.breadcrumb_name ? choice.breadcrumb_name : choice.name),
                        href: nextChoice ? choice.href : null
                    }
                }
            }
            if (breadcrumb) {
                $scope.breadcrumbs.push(breadcrumb);
                if (!breadcrumb.href) {
                    break;
                }
            }
        }
    }

    $rootScope.navigation_manager.requireInitialized(function () {

        updateActiveState();

        $scope.$on('browse_navigation_state_change', function () {
            updateActiveState();
        });
    });

}]);